import { api } from "@/api/client";

const BASE_PATH = "instituicao";

export type SimNao = "S" | "N";

export interface InstituicaoRegistro {
  id?: number;
  razaoSocial: string;
  nomeFantasia: string;
  cnpj?: string;
  emailFinanceiro?: string;
  privadaFilantropica?: "P" | "V";
  seParteDeAssociacao?: SimNao;
  seSaoVicenteDePaulo?: SimNao;
  dataInicio?: string;
  nomeContato?: string;
  email?: string;
  telefone?: string;
  celular?: string;
  cep?: string;
  rua?: string;
  bairro?: string;
  municipio?: string;
  estado?: string;
  codigoUsuarioCliente: string;
  // Nenhum destes campos tinha validação de obrigatoriedade no formulário
  // legado (só razaoSocial, nomeFantasia, codigoUsuarioCliente e
  // motivoCancelamento tinham `dc-not-empty`) — registros antigos podem não
  // ter valor gravado, então são opcionais/nuláveis aqui também. Ver
  // formSchema.ts para o motivo completo.
  situacaoAdmin?: "A" | "T" | "I" | "C" | "E" | null;
  dataFimTrial?: string;
  diasTrial?: string;
  motivoCancelamento?: string;
  situacaoCs?: "ON" | "OG" | "EX" | "RE" | "RC" | null;
  plano?: "M" | "S" | "A" | null;
  dataRenovacaoPlano?: string;
  seBloqueiaDataHoraEvolucao?: SimNao | null;
  seMedicamentoGeral?: SimNao | null;
  seHomeCare?: SimNao | null;
  seControlarEstoque?: SimNao | null;
  seAppLiberado?: SimNao | null;
  seProgramacaoAutomatica?: SimNao | null;
  quantidadeDiasProgramacao?: number | null;
  seProgramacaoChecagem?: SimNao | null;
  quantidadeDiasProgramacaoChecagem?: number | null;
  seBloqueioFinanceiro?: SimNao;
  dataIgnorarBloqueio?: string;
  origemCadastro?: string;
}

export interface Stakeholder {
  stakeholderInstituicaoId?: number;
  nome: string;
  sobrenome: string;
  email: string;
  celular: string;
  cargo: string;
}

export interface InstituicaoVinculada {
  instituicaoVinculadaId?: number;
  codigoVinculada: string;
  tipoInstituicaoVinculada: "MATRIZ" | "FILIAL" | "";
}

export interface InstituicaoPayload {
  instituicao: InstituicaoRegistro;
  stakeholders: Stakeholder[];
  instituicoesVinculadas: InstituicaoVinculada[];
}

export async function getInstituicaoRegistro(id: number): Promise<InstituicaoRegistro> {
  const { data } = await api.get<InstituicaoRegistro>(`${BASE_PATH}/Instituicao/${id}`);
  return data;
}

export async function getStakeholders(instituicaoId: number): Promise<Stakeholder[]> {
  const { data } = await api.get<Stakeholder[]>(`${BASE_PATH}/StakeHolder/buscar/${instituicaoId}`);
  return data;
}

export async function getInstituicoesVinculadas(instituicaoId: number): Promise<InstituicaoVinculada[]> {
  const { data } = await api.get<InstituicaoVinculada[]>(`${BASE_PATH}/InstituicaoVinculada/buscar/${instituicaoId}`);
  return data;
}

export async function deleteStakeholder(stakeholderInstituicaoId: number): Promise<void> {
  await api.delete(`${BASE_PATH}/StakeHolder/excluir/${stakeholderInstituicaoId}`);
}

export async function deleteInstituicaoVinculada(instituicaoVinculadaId: number): Promise<void> {
  await api.delete(`${BASE_PATH}/InstituicaoVinculada/excluir/${instituicaoVinculadaId}`);
}

export async function saveInstituicao(payload: InstituicaoPayload): Promise<void> {
  await api.post(`${BASE_PATH}/Instituicao/nova/stakeholder`, payload);
}
